import {useEffect, useState} from 'react';
import {attachUserToWindow} from './auth.store';
import shieldClient from './shieldClient';

export const useAuth = () => {
  const [user, setUser] = useState(null);

  const logout = async () => {
    setUser(null);
    attachUserToWindow(null);
    await shieldClient.logoutSilently();
  };

  const getAuthenticatedUser = async () => {
    try {
      const authenticatedUser = await shieldClient.getShieldUser();
      setUser(authenticatedUser);
      attachUserToWindow(authenticatedUser);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    (async () => {
      await getAuthenticatedUser();
    })();
  }, []);

  return {
    user,
    logout
  };
};
